import React from "react";
import { cn } from "../../utils/utils";
import { useSearchParams } from "react-router-dom";

type Props = {
  generalINfo: any;
};

function InfoControll({ generalINfo }: Props) {
  const [searchParams] = useSearchParams();
  return (
    <div className="flex justify-between absolute z-50 p-6 items-center w-full min-w-[1180px] overflow-x-hidden">
      <div className="club flex items-center gap-2 flex-1">
        <img
          loading="lazy"
          src={generalINfo.club_id.logo}
          alt=""
          width={100}
          height={100}
          className="rounded-full w-[80px] h-[80px] object-cover"
        />
        <span className="text-lg text-primary dark:text-white font-bold">
          {generalINfo.club_id.name}
        </span>
      </div>
      <div className="p-2 px-4  bg-white rounded-l-full rounded-r-full min-w-[200px] flex flex-col border border-primary flex-1 max-w-[250px] w-fit">
        <div className="flex gap-4 pr-10">
          {generalINfo?.poster_url && (
            <img
              loading="lazy"
              src={generalINfo?.poster_url}
              alt=""
              className="rounded-full w-[60px] h-[60px] object-cover bg-red-100"
            />
          )}
          <div
            className={cn("flex  gap-2", generalINfo?.poster_url && "flex-col")}
          >
            <h3>{searchParams.get("name")}</h3>
            <p>{generalINfo?.tournament_type}</p>
          </div>
        </div>
      </div>
      <div className="sponsors flex items-center gap-2 flex-1 justify-end">
        {generalINfo.sponsor_ids.map((item: any) => {
          return item.logo_url ? (
            <img
              loading="lazy"
              src={item.logo_url}
              alt=""
              width={40}
              height={40}
              className="rounded-full w-[80px] h-[80px] object-cover border border-primary"
            />
          ) : (
            <></>
          );
        })}
      </div>
    </div>
  );
}

export default InfoControll;
